import { ToastContainer } from 'react-toastify';
import { Asset, Box, useThemeValue } from '@altermaind/web/ui';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { UserInfo } from '@/_shared/components/UserInfo';
import { Roles } from '@/_shared/constants/roles';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { WizardSurvey } from '../components';
// eslint-disable-next-line @altermaind/no-build-import
import 'react-toastify/dist/ReactToastify.css';

export const SurveyToCompleteScreen = () => {
  const { styleResponsive } = useResponsiveStyle();

  const primary = useThemeValue('colors', 'primary/background') || 'transparent';
  const firstGradient = {
    positionY: 'top',
    positionX: 'center',
    width: '50%',
    height: '250px',
  };
  const secondGradient = {
    positionY: 'bottom',
    positionX: 'left',
    width: '80%',
    height: '400px',
  };
  const primaryBg = convertColorToRgba(primary, 1);
  const radialBg = `radial-gradient(${firstGradient.width} ${firstGradient.height} ellipse at ${firstGradient.positionY} ${firstGradient.positionX},#6b34fc, transparent, transparent), radial-gradient(${secondGradient.width} ${secondGradient.height} ellipse at ${secondGradient.positionY} ${secondGradient.positionX}, #6b34fc, ${primaryBg}, ${primaryBg})`;

  return (
    <Box width='100%' p='xs' minHeight='100vh' style={{ background: radialBg }}>
      <Box
        justifyContent='space-between'
        alignItems='center'
        pt='s'
        display='flex'
        flexDirection='row'
        pb='s'
      >
        <Box>
          <Asset domain='images' name='logoDark' width='150' />
        </Box>
        <Box>
          <UserInfo />
        </Box>
      </Box>
      <ClaimsComponent roles={[Roles.Manager, Roles.Employee]}>
        <Box
          display='flex'
          flexDirection='column'
          maxWidth='1400px'
          mx='auto'
          px={styleResponsive({
            breakPoints: { mobile: 'xs', tablet: 'huge', desktop: 'huge' },
          })}
        >
          <WizardSurvey />
        </Box>
      </ClaimsComponent>
      <ToastContainer style={{ zIndex: 99999999 }} />
    </Box>
  );
};
